import {bindable ,observable} from 'aurelia-framework';
import moment from 'moment';
import $ from 'jquery'

export class WlPricingTable {

  @bindable  starterFee;
  @bindable  starterUserFee;
  @bindable  currencySign ;
  @bindable  unlimitedFee;
  @bindable @observable subscription;

  constructor() {


  }

  attached() {

  }

  activate(){

  }

  changeSubscription(subscription){
    this.subscription=subscription;
  }



  subscriptionChanged(newValue, oldValue) {
    // Handle value changes in the child component if needed.
  }

  handleChange(){
    // this.subscription=this.isYearlyPlus?"PLUSYEARLY":"PLUS"
  }
}
